export default __webpack_public_path__ + "static/media/card03.c70dac96.svg";